<template>
  <div class="CheckSeat bg-white">
    <h3 class="font16">
      选择座位
      <span class="fr gray">
        已选 <span class="black">{{ checkedNum }}</span>
        / {{ max }}个
      </span>
    </h3>

    <div class="seat-list">
      <van-cell-group>
        <van-cell
          :title="seat.seat.label"
          v-for="(seat, i) in SeatList"
          :key="i"
        >
          <van-stepper
            v-model="seat.value"
            min="0"
            :max="seat.max"
            theme="round"
            button-size="22"
            integer
            disable-input
          />
        </van-cell>
      </van-cell-group>
    </div>

    <p class="font10 gray">
      {{ $t('I071', '若剩余席位无法满足您的需求，系统将自动为您分配席位') }}
    </p>
  </div>
</template>

<script>
/**
 * 选座的： 商务座(9),特等座(P),一等座(M),二等座(O),软座(2),硬座(1),一等软座(7),二等软座(8),特等软座(E),多功能座(Q)
 * 选卧的： 高级软卧(6),软卧(4),硬卧(3),动卧(F),一等卧(I),二等卧(J),
 */
import { Cell, CellGroup, Stepper } from 'vant'

const SEATTYPE_21 = ['9', 'P', 'M', 'O', '2', '1', '7', '8', 'E', 'Q']
const SEATTYPE_345 = ['6', '4', '3', 'F', 'I', 'J']

const getSeatList = (seatType) => {
  if (SEATTYPE_345.includes(seatType)) {
    return [
      { label: '上铺铺位', value: '3' }, 
      { label: '中铺铺位', value: '4' },
      { label: '下铺铺位', value: '5' },
    ]
  } else if (SEATTYPE_21.includes(seatType)) {
    return [
      { label: '过道座位', value: '2' }, 
      { label: '靠窗座位', value: '1' },
    ]
  }
}

export default {
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Stepper.name]: Stepper,
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    max: {
      type: Number,
      default: 1
    },
    trainType: {
      type: String,
      default: ''
    },
    seatType: {
      type: String,
      default: 'O' // 默认 二等座（O）
    },
  },
  data() {
    return {
      SeatList: [],
    }
  },
  computed: {
    checkedNum () {
      return this.SeatList.reduce((total, seat) => {
        return total + seat.value
      }, 0)
    }
  },
  created () {
    getSeatList(this.seatType).forEach(seat => {
      this.SeatList.push({
        seat,
        value: 0,
        max: this.max
      })
    })
  },
  watch: {
    SeatList: {
      handler (val) {
        if (this.checkedNum === this.max && this.max !== 0) {
          val.forEach(seat => {
            seat.max = seat.value
          })
        } else {
          val.forEach(seat => {
            seat.max = this.max - this.checkedNum + seat.value
          })
        }
        
        if (this.checkedNum > 0) {
          let chooseSeats = []
          val.forEach(seat => {
            if (seat.value > 0) {
              chooseSeats.push(`${seat.seat.value}-${seat.value}`)
            }
          })
          this.value = chooseSeats.join()
        } else {
          this.value = ''
        }

      },
      deep: true
    },
    max: {
      handler (val) {
        if (this.checkedNum > val) {
          this.SeatList.forEach(seat => {
            seat.value = 0
          })

          this.value = ''
        } else {
          this.SeatList.forEach(seat => {
            seat.max += val - this.checkedNum
          })
        }
      },
      immediate: true
    },
    value (val) {
      this.$emit('update:value', val)
    },
  }
}
</script>

<style lang="less">
.CheckSeat {
  padding: 10px 16px 0;

  h3 {
    margin: 0;
  }

  p {
    margin: 0;
    line-height: 30px;
  }

  .seat-list {
    padding: 10px 0;
  }
}
</style>
